import { render, staticRenderFns } from "./g-download-button.vue?vue&type=template&id=3b6918c0&"
import script from "./g-download-button.vue?vue&type=script&lang=js&"
export * from "./g-download-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports